import React from 'react';
import Form from "react-bootstrap/Form";

const HomeInfoForm = ({fields, handleFieldChange, messages, page, isEdit}) => {
  return (
    <>
      <h3>自宅</h3>
      <dl>
        <dt>郵便番号<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="homePostalCode" size="lg">
            <Form.Control
              type="text"
              name="homePostalCode"
              value={fields.homePostalCode}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>ハイフンで区切ってください（半角）例: 123-4567</p>
          <p id="homePostalCodeMessage" className="errorMessages">{messages.homePostalCode.n}</p>
        </dd>

        <dt>現住所<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="homeAddress" size="lg">
            <Form.Control
              type="text"
              name="homeAddress"
              value={fields.homeAddress ? fields.homeAddress.replace('#', ' ') : ""}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="homeAddressMessage" className="errorMessages">{messages.homeAddress.n}</p>
        </dd>

        <dt>現住所（フリガナ）<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="homeAddressKana" size="lg">
            <Form.Control
              type="text"
              name="homeAddressKana"
              value={fields.homeAddressKana}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="homeAddressKanaMessage" className="errorMessages">{messages.homeAddressKana.n}</p>
        </dd>

        <dt>電話番号<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="homeTel" size="lg">
            <Form.Control
              type="text"
              name="homeTel"
              value={fields.homeTel}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>ハイフンで区切ってください（半角）<br className="xs_block"/>例: 03-1234-5678</p>
          <p id="homeTelMessage" className="errorMessages">{messages.homeTel.n}</p>
        </dd>

        <dt>FAX</dt>
        <dd>
          <Form.Group controlId="homeFax" size="lg">
            <Form.Control
              type="text"
              name="homeFax"
              value={fields.homeFax}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>ハイフンで区切ってください（半角）<br className="xs_block"/>例: 03-1234-5678</p>
          <p id="homeFaxMessage" className="errorMessages">{messages.homeFax.n}</p>
        </dd>


      </dl>
    </>
  );
}

export default HomeInfoForm;
